import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';



const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_310';
const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Trabajadores independientes', listHelp: ['277'] },
  { text: "2", active: false, completed: false, tooltip: 'Factura electrónica', listHelp: ['278'] },
  //Honorarios
  { text: "3", active: false, completed: false, tooltip: 'Ingresos honorarios', listHelp: ['316'] },
  { text: "4", active: false, completed: false, tooltip: 'Retiro de ahorros', listHelp: ['345'] },
  { text: "5", active: false, completed: false, tooltip: 'Valor retirado', listHelp: ['346'] },
  { text: "6", active: false, completed: false, tooltip: 'Aportes obligatorios a salud', listHelp: ['317'] },
  { text: "7", active: false, completed: false, tooltip: 'Fondos de pensión', listHelp: ['318'] },
  { text: "8", active: false, completed: false, tooltip: 'RAIS', listHelp: ['319'] },
  { text: "9", active: false, completed: false, tooltip: 'Costos y gastos', listHelp: ['321'] },
  { text: "10", active: false, completed: false, tooltip: 'Aporte ahorros', listHelp: ['322'] },
  { text: "11", active: false, completed: false, tooltip: 'Comunidad andina', listHelp: ['288'] },
  { text: "12", active: false, completed: false, tooltip: 'Préstamos vivienda', listHelp: ['325'] },
  { text: "13", active: false, completed: false, tooltip: 'Préstamos educativos', listHelp: ['327'] },
  { text: "14", active: false, completed: false, tooltip: 'Dependencia', listHelp: ['329'] },
  { text: "15", active: false, completed: false, tooltip: 'Dependencia datos', listHelp: ['331'] },
  { text: "16", active: false, completed: false, tooltip: 'Prepagada datos', listHelp: ['334'] },
  { text: "17", active: false, completed: false, tooltip: 'Aportes cesantías', listHelp: ['340'] },
  { text: "18", active: false, completed: false, tooltip: 'Donación educación', listHelp: ['337'] },
  { text: "19", active: false, completed: false, tooltip: '4x1000', listHelp: ['338'] },
  { text: "20", active: false, completed: false, tooltip: 'Pérdidas declaradas', listHelp: ['342'] },
  { text: "21", active: false, completed: false, tooltip: 'Valor pérdidas declaradas', listHelp: ['343'] },
  //Renta laboral
  { text: "22", active: false, completed: false, tooltip: 'Ingresos honorarios', listHelp: ['279'] },
  { text: "23", active: false, completed: false, tooltip: 'Retiro de ahorros', listHelp: ['280'] },
  { text: "24", active: false, completed: false, tooltip: 'Valor retirado', listHelp: ['281'] },
  { text: "25", active: false, completed: false, tooltip: 'Aportes obligatorios a salud', listHelp: ['282'] },
  { text: "26", active: false, completed: false, tooltip: 'Fondos de pensión', listHelp: ['283'] },
  { text: "27", active: false, completed: false, tooltip: 'RAIS', listHelp: ['284'] },
  { text: "28", active: false, completed: false, tooltip: 'Aporte ahorros', listHelp: ['286'] },
  { text: "29", active: false, completed: false, tooltip: 'Comunidad andina', listHelp: ['288'] },
  { text: "30", active: false, completed: false, tooltip: 'Préstamos vivienda', listHelp: ['291'] },
  { text: "31", active: false, completed: false, tooltip: 'Préstamos educativos', listHelp: ['293'] },
  { text: "32", active: false, completed: false, tooltip: 'Dependencia', listHelp: ['295'] },
  { text: "33", active: false, completed: false, tooltip: 'Dependencia datos', listHelp: ['297'] },
  { text: "34", active: false, completed: false, tooltip: 'Prepagada datos', listHelp: ['300'] },
  { text: "35", active: false, completed: false, tooltip: 'Aportes cesantías', listHelp: ['306'] },
  { text: "36", active: false, completed: false, tooltip: 'Donación educación', listHelp: ['303'] },
  { text: "37", active: false, completed: false, tooltip: '4x1000', listHelp: ['304'] },
  //1 trabajador >90dias o mas de 2
  { text: "38", active: false, completed: false, tooltip: 'Ingresos no laboral prestación', listHelp: ['664'] }
];

@Component({
  selector: 'app-renta-laboral-prestacion-servicios-modal',
  templateUrl: './renta-laboral-prestacion-servicios-modal.component.html',
  styleUrls: ['./renta-laboral-prestacion-servicios-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio, 
    DValorDominio,
    DBasicosParametricasServicios 
  ]
})
export class RentaLaboralPrestacionServiciosModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  showSave:boolean = false;
  public UVT:string='';

  tiposDocumentofiltrado: DValorDominio[] = [];
  tiposParentesco: DValorDominio[] = [];

  constructor(
    public dialogRef: MatDialogRef<RentaLaboralPrestacionServiciosModalComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected inicializeModelo() {

    if (this.model.doc.cuerpo.cs_id_301 == undefined) this.model.doc.cuerpo.cs_id_301 = false;//number
    if (this.model.doc.cuerpo.cs_id_302 == undefined) this.model.doc.cuerpo.cs_id_302 = "";//number
    if (this.model.doc.cuerpo.cs_id_303 == undefined) this.model.doc.cuerpo.cs_id_303 = "0";//number
    if (this.model.doc.cuerpo.cs_id_304 == undefined) this.model.doc.cuerpo.cs_id_304 = "0";//number
    if (this.model.doc.cuerpo.cs_id_305 == undefined) this.model.doc.cuerpo.cs_id_305 = "0";//number
    if (this.model.doc.cuerpo.cs_id_306 == undefined) this.model.doc.cuerpo.cs_id_306 = "0";//number
    if (this.model.doc.cuerpo.cs_id_307 == undefined) this.model.doc.cuerpo.cs_id_307 = "0";//number
    if (this.model.doc.cuerpo.cs_id_308 == undefined) this.model.doc.cuerpo.cs_id_308 = "0";//number
    if (this.model.doc.cuerpo.cs_id_310 == undefined) this.model.doc.cuerpo.cs_id_310 = "0";//number
    if (this.model.doc.cuerpo.cs_id_311 == undefined) this.model.doc.cuerpo.cs_id_311 = "0";//number
    if (this.model.doc.cuerpo.cs_id_316 == undefined) this.model.doc.cuerpo.cs_id_316 = "0";//number
    if (this.model.doc.cuerpo.cs_id_317 == undefined) this.model.doc.cuerpo.cs_id_317 = "0";//number
    if (this.model.doc.cuerpo.cs_id_318 == undefined) this.model.doc.cuerpo.cs_id_318 = "0";//number
    if (this.model.doc.cuerpo.cs_id_319 == undefined) this.model.doc.cuerpo.cs_id_319 = "0";//number
    if (this.model.doc.cuerpo.cs_id_320 == undefined) this.model.doc.cuerpo.cs_id_320 = "0";//number
    if (this.model.doc.cuerpo.cs_id_321 == undefined) this.model.doc.cuerpo.cs_id_321 = "0";//number
    if (this.model.doc.cuerpo.cs_id_322 == undefined) this.model.doc.cuerpo.cs_id_322 = "0";//number
    if (this.model.doc.cuerpo.cs_id_323 == undefined) this.model.doc.cuerpo.cs_id_323 = "0";//number
    if (this.model.doc.cuerpo.cs_id_324 == undefined) this.model.doc.cuerpo.cs_id_324 = "0";//number
    if (this.model.doc.cuerpo.cs_id_325 == undefined) this.model.doc.cuerpo.cs_id_325 = "0";//number
    if (this.model.doc.cuerpo.cs_id_326 == undefined) this.model.doc.cuerpo.cs_id_326 = "0";//number
    if (this.model.doc.cuerpo.cs_id_327 == undefined) this.model.doc.cuerpo.cs_id_327 = "0";//number
    if (this.model.doc.cuerpo.cs_id_328 == undefined) this.model.doc.cuerpo.cs_id_328 = "0";//number
    if (this.model.doc.cuerpo.cs_id_329 == undefined) this.model.doc.cuerpo.cs_id_329 = null;//Boolean
    if (this.model.doc.cuerpo.cs_id_330 == undefined) this.model.doc.cuerpo.cs_id_330 = "0";//number
    if (this.model.doc.cuerpo.cs_id_331 == undefined) this.model.doc.cuerpo.cs_id_331 = "0";//number
    if (this.model.doc.cuerpo.cs_id_332 == undefined) this.model.doc.cuerpo.cs_id_332 = "0";//number
    if (this.model.doc.cuerpo.cs_id_333 == undefined) this.model.doc.cuerpo.cs_id_333 = "0";//number
    if (this.model.doc.cuerpo.cs_id_334 == undefined) this.model.doc.cuerpo.cs_id_334 = "0";//number
    if (this.model.doc.cuerpo.cs_id_335 == undefined) this.model.doc.cuerpo.cs_id_335 = "0";//number
    if (this.model.doc.cuerpo.cs_id_336 == undefined) this.model.doc.cuerpo.cs_id_336 = "0";//number
    if (this.model.doc.cuerpo.cs_id_337 == undefined) this.model.doc.cuerpo.cs_id_337 = "0";//number
    if (this.model.doc.cuerpo.cs_id_338 == undefined) this.model.doc.cuerpo.cs_id_338 = "0";//number
    if (this.model.doc.cuerpo.cs_id_339 == undefined) this.model.doc.cuerpo.cs_id_339 = "0";//number
    if (this.model.doc.cuerpo.cs_id_340 == undefined) this.model.doc.cuerpo.cs_id_340 = "0";//number
    if (this.model.doc.cuerpo.cs_id_341 == undefined) this.model.doc.cuerpo.cs_id_341 = "0";//number
    if (this.model.doc.cuerpo.cs_id_342 == undefined) this.model.doc.cuerpo.cs_id_342 = null;//Boolean
    if (this.model.doc.cuerpo.cs_id_343 == undefined) this.model.doc.cuerpo.cs_id_343 = "0";//number
    if (this.model.doc.cuerpo.cs_id_345 == undefined) this.model.doc.cuerpo.cs_id_316 = "0";//number
    if (this.model.doc.cuerpo.cs_id_345 == undefined) this.model.doc.cuerpo.cs_id_345 = null;//Boolean
    if (this.model.doc.cuerpo.cs_id_346 == undefined) this.model.doc.cuerpo.cs_id_346 = "0";//number
    if (this.model.doc.cuerpo.cs_id_347 == undefined) this.model.doc.cuerpo.cs_id_347 = "0";//number
    if (this.model.doc.cuerpo.cs_id_664 == undefined) this.model.doc.cuerpo.cs_id_664 = "0";//number
    if (this.model.doc.cuerpo.cs_id_669 == undefined) this.model.doc.cuerpo.cs_id_669 = "0";//number

  }

  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " + val);
    switch (this.indexStepper) {
      case 0:
        if (this.validateHasModalValues(this.indexStepper,val)) {
          let texConfirm="";
          if (val == "0" || val == "1") {
            texConfirm="Esta cambiando su respuesta a '" + (val=="0"?"Ninguno":"Una persona por menos de 90 días") + "', sin embargo se encontraron datos diligenciados para las opciones 'Una persona por más de 90 días' o 'Dos o más personas', si confirma se eliminarán las respuestas ingresadas para esta pregunta ¿Desea confirmar?"
          }
          if (val == "2" || val == "3") {
            texConfirm="Esta cambiando su respuesta a '" + (val=="2"?"Una persona por más de 90 días":"Dos o más personas") + "', sin embargo se encontraron datos diligenciados para las opciones 'Ninguna' o 'Una persona por menos de 90 días', si confirma se eliminarán las respuestas ingresadas para esta pregunta ¿Desea confirmar?"
          }
          this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',texConfirm).afterClosed().subscribe(result => {
            if (result) {
              this.cleanModalValues(this.indexStepper,val);
              this.model.doc.cuerpo.cs_id_277 = val;
            }
          });
        } else {
          this.model.doc.cuerpo.cs_id_277 = val;
        }
        if (this.model.doc.cuerpo.cs_id_277 == "2" || this.model.doc.cuerpo.cs_id_277 == "3") {
          //this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
          //this.updateIndicadorAvance(this.indexStepper);
          //this.validateShowSave();
          this.validateBtnRightActive();
        }
        

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 1:
        if (this.validateHasModalValues(this.indexStepper,val)) {
          this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Esta cambiando su respuesta a '" + (val=="1"?"SI":"NO") + "', sin embargo se encontraron datos diligenciados para " + (val=="1"?"'RENTA LABORAL'":"'RENTA HONORARIOS'") + ", si confirma se eliminarán las respuestas ingresadas para esta pregunta ¿Desea confirmar?").afterClosed().subscribe(result => {
            if (result) {
              this.cleanModalValues(this.indexStepper,val);
              this.model.doc.cuerpo.cs_id_278 = val;
            }
          });
        } else {
          this.model.doc.cuerpo.cs_id_278 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 3:
        if (val == "0") {
          if (this.validateHasModalValues(this.indexStepper)) {
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_345 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          } else {
            this.model.doc.cuerpo.cs_id_345 = val;
          }
          //this.updateIndicadorAvance();
        } else {
          this.model.doc.cuerpo.cs_id_345 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 13:
        if (val == "0") {
          if (this.validateHasModalValues(this.indexStepper)) {
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_329 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          } else {
            this.model.doc.cuerpo.cs_id_329 = val;
          }
        } else {
          this.model.doc.cuerpo.cs_id_329 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 19:
        if (val == "0") {
          if (this.validateHasModalValues(this.indexStepper)) {
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_342 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          } else {
            this.model.doc.cuerpo.cs_id_342 = val;
          }
          this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
          this.updateIndicadorAvance(this.indexStepper);
          this.validateShowSave();
          this.validateBtnRightActive();
        } else {
          this.model.doc.cuerpo.cs_id_342 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val == "1") {
          this.buttonRight.nativeElement.disabled = false;
        }else{
          this.buttonRight.nativeElement.disabled = true;
        }
        
        break;


      case 22:
        if (val == "0") {
          if (this.validateHasModalValues(this.indexStepper)) {
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_280 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          } else {
            this.model.doc.cuerpo.cs_id_280 = val;
          }
        } else {
          this.model.doc.cuerpo.cs_id_280 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 31:
        if (val == "0") {
          if (this.validateHasModalValues(this.indexStepper)) {
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_295 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          } else {
            this.model.doc.cuerpo.cs_id_295 = val;
          }
        } else {
          this.model.doc.cuerpo.cs_id_295 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if (val != undefined && val != "") {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion: number, val?:string): boolean {
    let hasValues: boolean = false;
    switch (indexQuestion) {//Pregunta Actualizar 
      case 0:
        if (val == "0" || val == "1") {
          //Revisa 1>=90 - 2 o más
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_664, "0")) {hasValues = true;break;}
        }
        if (val == "2" || val == "3") {
          //Revisa 0 - 1 <90
          if (this.model.doc.cuerpo.cs_id_278=="1" || this.model.doc.cuerpo.cs_id_278=="0") {hasValues = true;break;}
        }
        break;
      case 1:  
        if(val=="0"){
          //Revisa honorarios
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_316, "0")) {hasValues = true;break;}
          if (this.model.doc.cuerpo.cs_id_345=="1" || this.model.doc.cuerpo.cs_id_345=="0") {hasValues = true;break;}
        }
        if(val=="1"){
          //Revisa renta laboral
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_279, "0")) {hasValues = true;break;}
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_290, "0")) {hasValues = true;break;}
          if (this.model.doc.cuerpo.cs_id_280=="1" || this.model.doc.cuerpo.cs_id_280=="0") {hasValues = true;break;}
        }
        break;
      case 3:
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_346, "0")) {hasValues = true;break;}
        break;
      case 13:
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_331, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_332, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_333, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_347, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_330, "0")) {hasValues = true;break;}
        break;
      case 19:
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_343, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_344, "0")) {hasValues = true;break;}
        break;
      case 22:
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_281, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_282, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_283, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_284, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_285, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_286, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_287, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_288, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_291, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_292, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_293, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_294, "0")) {hasValues = true;break;}
        break;
      case 31:
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_297, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_298, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_299, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_669, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_296, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_300, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_301, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_302, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_306, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_307, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_303, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_304, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_305, "0")) {hasValues = true;break;}
        if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_308, "0")) {hasValues = true;break;}
        break;
  
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal: number, val?:string) {
    switch (indexQuestionModal) {
      case 0:
        if (val == "0" || val == "1") {
          this.model.doc.cuerpo.cs_id_664 = 0;
        }else{
          this.model.doc.cuerpo.cs_id_278 = null;
          this.model.doc.cuerpo.cs_id_316 = "0";  
          this.model.doc.cuerpo.cs_id_345 = null;
          this.model.doc.cuerpo.cs_id_346 = "0";
          this.model.doc.cuerpo.cs_id_317 = "0";
          this.model.doc.cuerpo.cs_id_318 = "0";
          this.model.doc.cuerpo.cs_id_319 = "0";
          this.model.doc.cuerpo.cs_id_320 = "0";
          this.model.doc.cuerpo.cs_id_321 = "0";
          this.model.doc.cuerpo.cs_id_322 = "0";
          this.model.doc.cuerpo.cs_id_323 = "0";
          this.model.doc.cuerpo.cs_id_324 = "0";
          this.model.doc.cuerpo.cs_id_325 = "0";
          this.model.doc.cuerpo.cs_id_326 = "0";
          this.model.doc.cuerpo.cs_id_327 = "0";
          this.model.doc.cuerpo.cs_id_328 = "0";
          this.model.doc.cuerpo.cs_id_329 = null;
          this.model.doc.cuerpo.cs_id_331 = "0";
          this.model.doc.cuerpo.cs_id_332 = "0";
          this.model.doc.cuerpo.cs_id_333 = "0";
          this.model.doc.cuerpo.cs_id_347 = "0";
          this.model.doc.cuerpo.cs_id_330 = "0";
          this.model.doc.cuerpo.cs_id_334 = "0";
          this.model.doc.cuerpo.cs_id_336 = "0";
          this.model.doc.cuerpo.cs_id_335 = "0";
          this.model.doc.cuerpo.cs_id_340 = "0";
          this.model.doc.cuerpo.cs_id_341 = "0";
          this.model.doc.cuerpo.cs_id_337 = "0";
          this.model.doc.cuerpo.cs_id_338 = "0";
          this.model.doc.cuerpo.cs_id_339 = "0";
          this.model.doc.cuerpo.cs_id_342 = null;
          this.model.doc.cuerpo.cs_id_343 = "0";
          this.model.doc.cuerpo.cs_id_344 = "0";
          
          this.model.doc.cuerpo.cs_id_279 = "0";
          this.model.doc.cuerpo.cs_id_290 = "0";
          this.model.doc.cuerpo.cs_id_280 = null;
          this.model.doc.cuerpo.cs_id_281 = "0";
          this.model.doc.cuerpo.cs_id_282 = "0";
          this.model.doc.cuerpo.cs_id_283 = "0";
          this.model.doc.cuerpo.cs_id_284 = "0";
          this.model.doc.cuerpo.cs_id_285 = "0";
          this.model.doc.cuerpo.cs_id_286 = "0";
          this.model.doc.cuerpo.cs_id_287 = "0";
          this.model.doc.cuerpo.cs_id_288 = "0";
          this.model.doc.cuerpo.cs_id_291 = "0";
          this.model.doc.cuerpo.cs_id_292 = "0";
          this.model.doc.cuerpo.cs_id_293 = "0";
          this.model.doc.cuerpo.cs_id_294 = "0";
          this.model.doc.cuerpo.cs_id_295 = null;
          this.model.doc.cuerpo.cs_id_297 = "0";
          this.model.doc.cuerpo.cs_id_298 = "0";
          this.model.doc.cuerpo.cs_id_299 = "0";
          this.model.doc.cuerpo.cs_id_669 = "0";
          this.model.doc.cuerpo.cs_id_296 = "0";
          this.model.doc.cuerpo.cs_id_300 = "0";
          this.model.doc.cuerpo.cs_id_301 = "0";
          this.model.doc.cuerpo.cs_id_302 = "0";
          this.model.doc.cuerpo.cs_id_306 = "0";
          this.model.doc.cuerpo.cs_id_307 = "0";
          this.model.doc.cuerpo.cs_id_303 = "0";
        }
        break;
      case 1:
        if(val=="0"){
          this.model.doc.cuerpo.cs_id_316 = "0";  
          this.model.doc.cuerpo.cs_id_345 = null;
          this.model.doc.cuerpo.cs_id_346 = "0";
          this.model.doc.cuerpo.cs_id_317 = "0";
          this.model.doc.cuerpo.cs_id_318 = "0";
          this.model.doc.cuerpo.cs_id_319 = "0";
          this.model.doc.cuerpo.cs_id_320 = "0";
          this.model.doc.cuerpo.cs_id_321 = "0";
          this.model.doc.cuerpo.cs_id_322 = "0";
          this.model.doc.cuerpo.cs_id_323 = "0";
          this.model.doc.cuerpo.cs_id_324 = "0";
          this.model.doc.cuerpo.cs_id_325 = "0";
          this.model.doc.cuerpo.cs_id_326 = "0";
          this.model.doc.cuerpo.cs_id_327 = "0";
          this.model.doc.cuerpo.cs_id_328 = "0";
          this.model.doc.cuerpo.cs_id_329 = null;
          this.model.doc.cuerpo.cs_id_331 = "0";
          this.model.doc.cuerpo.cs_id_332 = "0";
          this.model.doc.cuerpo.cs_id_333 = "0";
          this.model.doc.cuerpo.cs_id_347 = "0";
          this.model.doc.cuerpo.cs_id_330 = "0";
          this.model.doc.cuerpo.cs_id_334 = "0";
          this.model.doc.cuerpo.cs_id_336 = "0";
          this.model.doc.cuerpo.cs_id_335 = "0";
          this.model.doc.cuerpo.cs_id_340 = "0";
          this.model.doc.cuerpo.cs_id_341 = "0";
          this.model.doc.cuerpo.cs_id_337 = "0";
          this.model.doc.cuerpo.cs_id_338 = "0";
          this.model.doc.cuerpo.cs_id_339 = "0";
          this.model.doc.cuerpo.cs_id_342 = null;
          this.model.doc.cuerpo.cs_id_343 = "0";
          this.model.doc.cuerpo.cs_id_344 = "0";
        }
        if(val=="1"){
          this.model.doc.cuerpo.cs_id_279 = "0";
          this.model.doc.cuerpo.cs_id_290 = "0";
          this.model.doc.cuerpo.cs_id_280 = null;
          this.model.doc.cuerpo.cs_id_281 = "0";
          this.model.doc.cuerpo.cs_id_282 = "0";
          this.model.doc.cuerpo.cs_id_283 = "0";
          this.model.doc.cuerpo.cs_id_284 = "0";
          this.model.doc.cuerpo.cs_id_285 = "0";
          this.model.doc.cuerpo.cs_id_286 = "0";
          this.model.doc.cuerpo.cs_id_287 = "0";
          this.model.doc.cuerpo.cs_id_288 = "0";
          this.model.doc.cuerpo.cs_id_291 = "0";
          this.model.doc.cuerpo.cs_id_292 = "0";
          this.model.doc.cuerpo.cs_id_293 = "0";
          this.model.doc.cuerpo.cs_id_294 = "0";
          this.model.doc.cuerpo.cs_id_295 = null;
          this.model.doc.cuerpo.cs_id_297 = "0";
          this.model.doc.cuerpo.cs_id_298 = "0";
          this.model.doc.cuerpo.cs_id_299 = "0";
          this.model.doc.cuerpo.cs_id_669 = "0";
          this.model.doc.cuerpo.cs_id_296 = "0";
          this.model.doc.cuerpo.cs_id_300 = "0";
          this.model.doc.cuerpo.cs_id_301 = "0";
          this.model.doc.cuerpo.cs_id_302 = "0";
          this.model.doc.cuerpo.cs_id_306 = "0";
          this.model.doc.cuerpo.cs_id_307 = "0";
          this.model.doc.cuerpo.cs_id_303 = "0";
          this.model.doc.cuerpo.cs_id_304 = "0";
          this.model.doc.cuerpo.cs_id_305 = "0";
          this.model.doc.cuerpo.cs_id_308 = "0";
        }
        break;
      case 3:
        this.model.doc.cuerpo.cs_id_346 = "0";
        break;
      case 13:
        this.model.doc.cuerpo.cs_id_331 = "0";
        this.model.doc.cuerpo.cs_id_332 = "0";
        this.model.doc.cuerpo.cs_id_333 = "0";
        this.model.doc.cuerpo.cs_id_347 = "0";
        this.model.doc.cuerpo.cs_id_330 = "0";
        break;
      case 19:
        this.model.doc.cuerpo.cs_id_343 = "0";
        this.model.doc.cuerpo.cs_id_344 = "0";
        break;
      case 22:
        this.model.doc.cuerpo.cs_id_281 = "0";
        this.model.doc.cuerpo.cs_id_282 = "0";
        this.model.doc.cuerpo.cs_id_283 = "0";
        this.model.doc.cuerpo.cs_id_284 = "0";
        this.model.doc.cuerpo.cs_id_285 = "0";
        this.model.doc.cuerpo.cs_id_286 = "0";
        this.model.doc.cuerpo.cs_id_287 = "0";
        this.model.doc.cuerpo.cs_id_288 = "0";
        this.model.doc.cuerpo.cs_id_291 = "0";
        this.model.doc.cuerpo.cs_id_292 = "0";
        this.model.doc.cuerpo.cs_id_293 = "0";
        this.model.doc.cuerpo.cs_id_294 = "0";
        break;
      case 31:
        this.model.doc.cuerpo.cs_id_297 = "0";
        this.model.doc.cuerpo.cs_id_298 = "0";
        this.model.doc.cuerpo.cs_id_299 = "0";
        this.model.doc.cuerpo.cs_id_669 = "0";
        this.model.doc.cuerpo.cs_id_296 = "0";
        this.model.doc.cuerpo.cs_id_300 = "0";
        this.model.doc.cuerpo.cs_id_301 = "0";
        this.model.doc.cuerpo.cs_id_302 = "0";
        this.model.doc.cuerpo.cs_id_306 = "0";
        this.model.doc.cuerpo.cs_id_307 = "0";
        this.model.doc.cuerpo.cs_id_303 = "0";
        this.model.doc.cuerpo.cs_id_304 = "0";
        this.model.doc.cuerpo.cs_id_305 = "0";
        this.model.doc.cuerpo.cs_id_308 = "0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS: number): boolean {
    let habilitado = true;
    
    //Si no ha respondido en RT21 no puede saltar preguntas
    if ((indexS >= 0 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_277 == undefined
        || this.model.doc.cuerpo.cs_id_277 == ""))) {
      habilitado = false;
    }
    //Si responde 2 o 3 en RT21 debe saltar preguntas del indexStepper
    else if (((indexS >= 1 && indexS < 37)
      && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_277 == "2" ||
        this.model.doc.cuerpo.cs_id_277 == "3"))) {
      habilitado = false;
    }

    //Si no ha respondido en RT22 no puede saltar preguntas
    else if ((indexS >= 2 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_278 == undefined
        || this.model.doc.cuerpo.cs_id_278 == ""))) {
      habilitado = false;
    }
    //Si responde NO en RT22 debe saltar preguntas del indexStepper
    else if (((indexS >= 2 && indexS < 20)
      && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_278 == "0"
      ))) {
      habilitado = false;
    }

    //Honorarios

    //Si no ha respondido en RH118 no puede saltar preguntas
    else if ((indexS >= 4 && indexS <= 20
      && (this.model.doc.cuerpo.cs_id_345 == undefined
        || this.model.doc.cuerpo.cs_id_345 == ""))) {
      habilitado = false;
    }
    //Si responde NO en RH118 debe saltar preguntas del indexStepper
    else if (((indexS == 4)
      && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_345 == "0"
      ))) {
      habilitado = false;
    }

    //Si no ha respondido en RH110 no puede saltar preguntas
    else if ((indexS >= 14 && indexS <= 20
      && (this.model.doc.cuerpo.cs_id_329 == undefined
        || this.model.doc.cuerpo.cs_id_329 == ""))) {
      habilitado = false;
    }
    //Si responde NO en RH110 debe saltar preguntas del indexStepper
    else if (((indexS == 14)
      && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_329 == "0"
      ))) {
      habilitado = false;
    }
    if(indexS == 15 && (this.model.doc.cuerpo.cs_id_329 == "1") && !this.operacionCs347()){
      habilitado = false;
    }

    //Si no ha respondido en RH116 no puede saltar preguntas

    else if ((indexS >= 20 && indexS <= 20
      && (this.model.doc.cuerpo.cs_id_342 == undefined
        || this.model.doc.cuerpo.cs_id_342 == ""))) {
      habilitado = false;
    }
    //Si responde 'NO' en RH116 debe saltar preguntas del indexStepper
    else if ((indexS >= 20 && indexS <= 20
      && (this.model.doc.cuerpo.cs_id_342 == "0"))) {
      habilitado = false;
    }
    else if ((indexS >= 21 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_342 == "0" || this.model.doc.cuerpo.cs_id_342 == "1"))) {
      habilitado = false;
    }

    else if ((indexS >= 21 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_342 == "0" || this.model.doc.cuerpo.cs_id_342 == "1"))) {
      habilitado = false;
    }

    //Renta laboral

    //Si no ha respondido no puede saltar preguntas
    if ((indexS >= 23 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_280 == undefined
        || this.model.doc.cuerpo.cs_id_280 == ""))) {
      habilitado = false;
    }
    //Si responde 'NO' debe saltar preguntas del indexStepper
    else if ((indexS == 23 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_280 == "0"))) {
      habilitado = false;
    }
    //Si no ha respondido no puede saltar preguntas
    if ((indexS >= 32 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_295 == undefined
        || this.model.doc.cuerpo.cs_id_295 == ""))) {
      habilitado = false;
    }
    //Si responde 'NO' debe saltar preguntas del indexStepper
    else if ((indexS == 32 && indexS <= 36
      && (this.model.doc.cuerpo.cs_id_295 == "0"))) {
      habilitado = false;
    }
    if(indexS == 33 && (this.model.doc.cuerpo.cs_id_295 == "1") && !this.operacionCs669()){
      habilitado = false;
    }

    //RT23 solo esta habilitado RT21(cas277) es 2o3
    if(indexS==37 && (this.model.doc.cuerpo.cs_id_277 == "0" || this.model.doc.cuerpo.cs_id_277 == "1")){
      habilitado = false;
    }

    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive() {
    //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
    switch (this.indexStepper) {
      case 0:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_277 == undefined || this.model.doc.cuerpo.cs_id_277 == "") {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 1:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_278 == undefined || this.model.doc.cuerpo.cs_id_278 == "") {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 3:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_345 == undefined || this.model.doc.cuerpo.cs_id_345 == "") {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 13:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_329 == undefined || this.model.doc.cuerpo.cs_id_329 == "") {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 14:
        if(!this.operacionCs347(true)){
          this.buttonRight.nativeElement.disabled = true;
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 19:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_342 == undefined || this.model.doc.cuerpo.cs_id_342 == ""  || this.model.doc.cuerpo.cs_id_342 == "0" ) {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 20:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        //if (this.model.doc.cuerpo.cs_id_342 == undefined || this.model.doc.cuerpo.cs_id_342 == ""  || this.model.doc.cuerpo.cs_id_342 == "" ) {
          this.buttonRight.nativeElement.disabled = true;
        //} else {
        //  this.buttonRight.nativeElement.disabled = false;
        //}
        break;
      case 22:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_280 == undefined || this.model.doc.cuerpo.cs_id_280 == "" ) {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 31:
        //Si no se ha seleccionado respuesta SI/NO deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_295 == undefined || this.model.doc.cuerpo.cs_id_295 == "") {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 32:
        if(!this.operacionCs669(true)){
          this.buttonRight.nativeElement.disabled = true;
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 36:
        //Si la respuesta en RT21 es 0 o 1 deshabilitar botón next
        if (this.model.doc.cuerpo.cs_id_277 == "0" || this.model.doc.cuerpo.cs_id_277 == "1") {
          this.buttonRight.nativeElement.disabled = true;
          this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
          this.updateIndicadorAvance(this.indexStepper);
          this.validateShowSave();
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        if (this.indexStepper === stepsList.length - 1) {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }

        break;
    }
  }



  //////////////////////////

  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected updateIndicadorAvance(indexS:number) {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (this.indexStepper > Number(casIndicadorAvance)) {
      //let indexS = this.indexStepper + 1;
      while (!this.validateStepHabilitado(indexS)) {
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = indexS.toString();
    }
    if (this.indexStepper == this.stepsList.length - 1) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while (!this.validateStepHabilitado(indexS)) {
      if (direction == DirectionType.previous) {
        indexS--;
      }
      if (direction == DirectionType.next) {
        indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?: boolean) {
    let casIndicadorAvance = this.obtenerCasIndicadorAvance();
    if (forceUpdateStepper) {
      this.changeStep(index);
      this.updateIndicadorAvance(index);
    } else if (this.validateStepHabilitado(index)) {
      let indexCalc = index - 1;
      if (indexCalc <= Number(casIndicadorAvance)) {
        this.changeStep(index);
        this.updateIndicadorAvance(index);
      } else {
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1=" + (indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  public closeModal() {
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1 || (this.indexStepper==19 && this.model.doc.cuerpo.cs_id_342 == "0") || this.indexStepper==20 || this.indexStepper==36){
      this.closeModal();
    }
  }

   
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
    case 275: this.operacionCs275(); break;
    case 312: this.operacionCs312(); break;
    case 279: this.operacionCs279(); break;
    case 290: this.operacionCs290(); break;
    case 280: this.operacionCs280(); break;
    case 281: this.operacionCs281(); break;
    case 282: this.operacionCs282(); break;
    case 283: this.operacionCs283(); break;
    case 284: this.operacionCs284(); break;
    case 285: this.operacionCs285(); break;
    case 286: this.operacionCs286(); break;
    case 287: this.operacionCs287(); break;
    case 288: this.operacionCs288(); break;
    case 291: this.operacionCs291(); break;
    case 292: this.operacionCs292(); break;
    case 293: this.operacionCs293(); break;
    case 294: this.operacionCs294(); break;
    case 296: this.operacionCs296(); break;
    case 300: this.operacionCs300(); break;
    case 302: this.operacionCs302(); break;
    case 301: this.operacionCs301(); break;
    case 306: this.operacionCs306(); break;
    case 307: this.operacionCs307(); break;
    case 303: this.operacionCs303(); break;
    case 304: this.operacionCs304(); break;
    case 305: this.operacionCs305(); break;
    case 316: this.operacionCs316(); break;
    case 345: this.operacionCs345(); break;
    case 346: this.operacionCs346(); break;
    case 317: this.operacionCs317(); break;
    case 318: this.operacionCs318(); break;
    case 319: this.operacionCs319(); break;
    case 320: this.operacionCs320(); break;
    case 321: this.operacionCs321(); break;
    case 322: this.operacionCs322(); break;
    case 323: this.operacionCs323(); break;
    case 324: this.operacionCs324(); break;
    case 325: this.operacionCs325(); break;
    case 326: this.operacionCs326(); break;
    case 327: this.operacionCs327(); break;
    case 328: this.operacionCs328(); break;
    case 330: this.operacionCs330(); break;
    case 334: this.operacionCs334(); break;
    case 336: this.operacionCs336(); break;
    case 335: this.operacionCs335(); break;
    case 340: this.operacionCs340(); break;
    case 341: this.operacionCs341(); break;
    case 337: this.operacionCs337(); break;
    case 338: this.operacionCs338(); break;
    case 339: this.operacionCs339(); break;
    case 342: this.operacionCs342(); break;
    case 343: this.operacionCs343(); break;
    case 297: this.operacionCs297(); break;
    case 298: this.operacionCs298(); break;
    case 299: this.operacionCs299(); break;
    case 669: this.operacionCs669(); break;
    case 331: this.operacionCs331(); break;
    case 332: this.operacionCs332(); break;
    case 333: this.operacionCs333(); break;
    case 347: this.operacionCs347(); break;
   }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
  }
  //es trabajador independiente por prestacion de servicios
operacionCs275(){
	const cas275 = this.model.doc.cuerpo.cs_id_275;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas275,"0")) {
		this.model.doc.cuerpo.cs_id_277="0";
		this.model.doc.cuerpo.cs_id_278=null;	
		this.model.doc.cuerpo.cs_id_664=0;	
	}
}

//es trabajador independiente por actividades técnicas
operacionCs312(){
	const cas312 = this.model.doc.cuerpo.cs_id_312;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas312,"0")) {
		this.model.doc.cuerpo.cs_id_314="0";
		this.model.doc.cuerpo.cs_id_315=null;	
		this.model.doc.cuerpo.cs_id_672=0;	
	}
}


//TRABAJADOR INDEPENDIENTE RENTA LABORAL


//ingresos 
operacionCs279() {
	const cas279 = this.model.doc.cuerpo.cs_id_279
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas279,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los honorarios y compensaciones de servicio no pueden ser cero");
      return;
   }
 }
 
  //número de meses
 operacionCs290() {
	const cas290 = this.model.doc.cuerpo.cs_id_290
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas290,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Debe especificar el número de meses a los cuales corresponde el ingreso");
      return;
   }
 }
 
  //retiro ahorros de cuentas AFC
 operacionCs280(){
	const cas280 = this.model.doc.cuerpo.cs_id_280;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas280,"0")) {
		this.model.doc.cuerpo.cs_id_281="0";
	}
}

//valor retirado cuentas AFC..
operacionCs281() {
	const cas281 = this.model.doc.cuerpo.cs_id_281
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas281,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los retiros no pueden ser cero");
      return
   }
 }
 
 
//aportes a salud
operacionCs282() {
	//no tiene validaciones
}

//aportes a pension
operacionCs283() {
	//no tiene validaciones
}

//cotizacion voluntaria RAIS
operacionCs284() {
	this.operacionCs285();
}


//Limitante cotizacion voluntaria RAIS
operacionCs285() {
	//Valor se calcula en recalculo casillas 210
}

//aportes voluntarios cuentas AFC...
operacionCs286() {
	//no tiene validaciones
	this.operacionCs287();
}

//Limitante aportes voluntarios cuentas AFC...
operacionCs287() {
  //Valor se calcula en recalculo casillas 210
}

//ingresos CAN
operacionCs288() {
	const cas288 = this.model.doc.cuerpo.cs_id_288;
	const cas279 = this.model.doc.cuerpo.cs_id_279;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas288,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas288,cas279)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_288="0";
	   }		
	}
}


//intereses prestamos de vivienda
operacionCs291(){
	const cas291 = this.model.doc.cuerpo.cs_id_291;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas291,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas258 = this.model.doc.cuerpo.cs_id_258;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas258,"0")) {
			this.model.doc.cuerpo.cs_id_291="0";
			this.model.doc.cuerpo.cs_id_292="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas325 = this.model.doc.cuerpo.cs_id_325;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas325,"0")) {
			this.model.doc.cuerpo.cs_id_291="0";
			this.model.doc.cuerpo.cs_id_292="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas412 = this.model.doc.cuerpo.cs_id_412;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas412,"0")) {
			this.model.doc.cuerpo.cs_id_291="0";
			this.model.doc.cuerpo.cs_id_292="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas519 = this.model.doc.cuerpo.cs_id_519;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas519,"0")) {
			this.model.doc.cuerpo.cs_id_291="0";
			this.model.doc.cuerpo.cs_id_292="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
	
	this.operacionCs292();
}

//limitante intereses prestamos de vivienda
operacionCs292(){
	const cas291 = this.model.doc.cuerpo.cs_id_291;
	const uvt1200 = "45605000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas291,uvt1200)) {
		this.model.doc.cuerpo.cs_id_292 = cas291;
	} else {
		this.model.doc.cuerpo.cs_id_292 = uvt1200;
	}
}

//intereses icetex
operacionCs293(){
	const cas293 = this.model.doc.cuerpo.cs_id_293;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas293,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas260 = this.model.doc.cuerpo.cs_id_260;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas260,"0")) {
			this.model.doc.cuerpo.cs_id_293="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas327 = this.model.doc.cuerpo.cs_id_327;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas327,"0")) {
			this.model.doc.cuerpo.cs_id_293="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas414 = this.model.doc.cuerpo.cs_id_414;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas414,"0")) {
			this.model.doc.cuerpo.cs_id_293="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas521 = this.model.doc.cuerpo.cs_id_521;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas521,"0")) {
			this.model.doc.cuerpo.cs_id_293="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
	
	this.operacionCs294();
}

//limitante intereses icetex
operacionCs294(){
	const cas293 = this.model.doc.cuerpo.cs_id_293;
	const uvt100 = "3800000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas293,uvt100)) {
		this.model.doc.cuerpo.cs_id_294 = cas293;
	} else {
		this.model.doc.cuerpo.cs_id_294 = uvt100;
	}
}

 operacionCs297(){
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_297,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el tipo de documento del dependiente económico');
			return false;
	    }		
    	
  }
  operacionCs298(){
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_298,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de documento del dependiente económico');
			return false;
	    }	
    }
  operacionCs299(){
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_299,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el parentesco con el dependiente económico');
			return false;
	    }	
  }
  operacionCs669(soloValidar?:boolean){
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_669,"0")) {
			if(!soloValidar){
        // this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de meses del año que tuvo la calidad de dependiente económico');
      }
			this.buttonRight.nativeElement.disabled = true;
      return false;
    }			
    this.buttonRight.nativeElement.disabled = false;
    return true;		
	}

  operacionCs331()
  {
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_331,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el tipo de documento del dependiente económico');
			return false;
	    }			
  }
  operacionCs332()
  {
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_332,"0")) {
			this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de documento del dependiente económico');
			return false;
	    }	
  }
  operacionCs333()
  {
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_333,"0")) {
			// this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el parentesco con el dependiente económico');
			return false;
	    }	
  }
  operacionCs347(soloValidar?:boolean)
  {
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_347,"0")) {
			if(!soloValidar){
        // this.dNotificacionServicio.mostrarDialogoInformacion('Debe especificar el número de meses del año que tuvo la calidad de dependiente económico');
      }
			this.buttonRight.nativeElement.disabled = true;
      return false;
	    }			
      this.buttonRight.nativeElement.disabled = false;
      return true;
	}
	

//limitante dependiente economico
operacionCs296() {
	//el valor del limitante se calcula en el 210
}

//medicina prepagada
operacionCs300(){
	
	const cas300 = this.model.doc.cuerpo.cs_id_300;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas300,"0")) {
		this.model.doc.cuerpo.cs_id_302="0";
		this.model.doc.cuerpo.cs_id_301="0";
	} else {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas269 = this.model.doc.cuerpo.cs_id_269;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas269,"0")) {
			this.model.doc.cuerpo.cs_id_300="0";
			this.model.doc.cuerpo.cs_id_302="0";
			this.model.doc.cuerpo.cs_id_301="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('El valor de medicina prepagada ya está diligenciado en las rentas de trabajo como asalariado')
			return;
		}
		
		const cas334 = this.model.doc.cuerpo.cs_id_334;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas334,"0")) {
			this.model.doc.cuerpo.cs_id_300="0";
			this.model.doc.cuerpo.cs_id_302="0";
			this.model.doc.cuerpo.cs_id_301="0";
			this.dNotificacionServicio.mostrarDialogoInformacion('El valor de medicina prepagada ya está diligenciado en las rentas por honorarios')
			return;
		}
		this.operacionCs301();	
	}
}

//número de meses medicina prepagada
operacionCs302() {
   this.operacionCs301();		
}

//limitante medicina prepagada
operacionCs301(){
	
	const cas300 = this.model.doc.cuerpo.cs_id_300;
	const cas302 = this.model.doc.cuerpo.cs_id_302;
	
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas300,"0") 
  || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas302,"0")) {
		this.model.doc.cuerpo.cs_id_301="0";
		return 
	}
	
	const valorTope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,cas300,cas302);
	
	let cas301 = "0";
	const uvt16 = "608064";
	const uvt192 = "7296768";
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorTope,uvt16)) {
		cas301 =  this.dutilidades.redondearValorMoneda(cas300,true);
	} else {
		cas301 = uvt192;
	}
	this.model.doc.cuerpo.cs_id_301 = cas301;
}

// aportes voluntarios a cesantias...
operacionCs306(){
	// no tiene validaciones
	this.operacionCs307();
}

//limitante aportes voluntarios cesantias
operacionCs307(){
	//Valor se calcula en recalculo casillas 210
}


//donacion para investigacion
operacionCs303(){
	
	const cas303 = this.model.doc.cuerpo.cs_id_303;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas303,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas271 = this.model.doc.cuerpo.cs_id_271;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas271,"0")) {
			this.model.doc.cuerpo.cs_id_303="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas337 = this.model.doc.cuerpo.cs_id_337;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas337,"0")) {
			this.model.doc.cuerpo.cs_id_303="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas416 = this.model.doc.cuerpo.cs_id_416;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas416,"0")) {
			this.model.doc.cuerpo.cs_id_303="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas523 = this.model.doc.cuerpo.cs_id_523;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas523,"0")) {
			this.model.doc.cuerpo.cs_id_303="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
}

//4 x mil
operacionCs304(){
	this.operacionCs305();
}


//limitante 4 x mil
operacionCs305(){
	const porcentajeTopeMax = "0.50";
	const cas304 = this.model.doc.cuerpo.cs_id_304;
	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas304,porcentajeTopeMax);
	this.model.doc.cuerpo.cs_id_305 = this.dutilidades.redondearValorMoneda(resultado ,true);
}
//TRABAJADOR INDEPENDIENTE HONORARIOS


//ingresos 
operacionCs316() {
	const cas316 = this.model.doc.cuerpo.cs_id_316
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas316,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los honorarios y compensaciones de servicio no pueden ser cero");
      return;
   }
 }
 

  //retiro ahorros de cuentas AFC
 operacionCs345(){
	const cas345 = this.model.doc.cuerpo.cs_id_345;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas345,"0")) {
		this.model.doc.cuerpo.cs_id_346="0";
	}
}

//valor retirado cuentas AFC..
operacionCs346() {
	const cas346 = this.model.doc.cuerpo.cs_id_346
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas346,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los retiros no pueden ser cero");
      return;
   }
 }

//aportes a salud
operacionCs317() {
	//no tiene validaciones
}

//aportes a pension
operacionCs318() {
	//no tiene validaciones
}

//cotizacion voluntaria RAIS
operacionCs319() {
	this.operacionCs320();
}

//Limitante cotizacion voluntaria RAIS
operacionCs320() {
	//Valor se calcula en recalculo casillas 210
}

//Costos y Gastos
operacionCs321() {
	//no tiene validaciones
}

//aportes voluntarios cuentas AFC...
operacionCs322() {
	//no tiene validaciones
	this.operacionCs323();
}

//Limitante aportes voluntarios cuentas AFC...
operacionCs323() {
  //Valor se calcula en recalculo casillas 210
}

//ingresos CAN
operacionCs324() {
	const cas324 = this.model.doc.cuerpo.cs_id_324;
	const cas316 = this.model.doc.cuerpo.cs_id_316;		
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas324,"0")) {
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas324,cas316)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_316="0";
	   }		
	}
}


//intereses prestamos de vivienda
operacionCs325(){
	const cas325 = this.model.doc.cuerpo.cs_id_325;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas325,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		
		const cas258 = this.model.doc.cuerpo.cs_id_258;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas258,"0")) {
			this.model.doc.cuerpo.cs_id_325="0";
			this.model.doc.cuerpo.cs_id_326="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas291 = this.model.doc.cuerpo.cs_id_291;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas291,"0")) {
			this.model.doc.cuerpo.cs_id_325="0";
			this.model.doc.cuerpo.cs_id_326="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas412 = this.model.doc.cuerpo.cs_id_412;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas412,"0")) {
			this.model.doc.cuerpo.cs_id_325="0";
			this.model.doc.cuerpo.cs_id_326="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas519 = this.model.doc.cuerpo.cs_id_519;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas519,"0")) {
			this.model.doc.cuerpo.cs_id_325="0";
			this.model.doc.cuerpo.cs_id_326="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
	
	this.operacionCs326();
}

//limitante intereses prestamos de vivienda
operacionCs326(){
	const cas325 = this.model.doc.cuerpo.cs_id_325;
	const uvt1200 = "45605000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas325,uvt1200)) {
		this.model.doc.cuerpo.cs_id_326 = cas325;
	} else {
		this.model.doc.cuerpo.cs_id_326 = uvt1200;
	}
}

//intereses icetex
operacionCs327(){
	const cas327 = this.model.doc.cuerpo.cs_id_327;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas327,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas260 = this.model.doc.cuerpo.cs_id_260;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas260,"0")) {
			this.model.doc.cuerpo.cs_id_327="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas293 = this.model.doc.cuerpo.cs_id_293;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas293,"0")) {
			this.model.doc.cuerpo.cs_id_327="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador indenpendiente");
			return
		}
		
		const cas414 = this.model.doc.cuerpo.cs_id_414;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas414,"0")) {
			this.model.doc.cuerpo.cs_id_327="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas521 = this.model.doc.cuerpo.cs_id_521;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas521,"0")) {
			this.model.doc.cuerpo.cs_id_327="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
	
	this.operacionCs328();
}

//limitante intereses icetex
operacionCs328(){
	const cas327 = this.model.doc.cuerpo.cs_id_327;
	const uvt100 = "3800000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas327,uvt100)) {
		this.model.doc.cuerpo.cs_id_328 = cas327;
	} else {
		this.model.doc.cuerpo.cs_id_328 = uvt100;
	}
}

//Tuvo dependiente economico?
/* 
OperacionCs329(){
	const cas329 = this.model.doc.cuerpo.cs_id_329;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas329,"0")) {
		this.dependienteAsalariado("0","0","0","0","0");
		this.dependienteIndependiente("0","0","0","0","0");
		this.dependienteHonorarios("0","0","0","0","0");
		
	} else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas331,"0")
		
		if !(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas264,"0")) {
			this.dependienteHonorarios("1",this.model.doc.cuerpo.cs_id_264,this.model.doc.cuerpo.cs_id_265,this.model.doc.cuerpo.cs_id_266,this.model.doc.cuerpo.cs_id_473);
			this.dependienteIndependiente("1",this.model.doc.cuerpo.cs_id_264,this.model.doc.cuerpo.cs_id_265,this.model.doc.cuerpo.cs_id_266,this.model.doc.cuerpo.cs_id_473);
		
		} else if !(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas297,"0")) {
			this.dependienteHonorarios("1",this.model.doc.cuerpo.cs_id_297,this.model.doc.cuerpo.cs_id_298,this.model.doc.cuerpo.cs_id_299,this.model.doc.cuerpo.cs_id_669);
			this.dependienteAsalariado("1",this.model.doc.cuerpo.cs_id_297,this.model.doc.cuerpo.cs_id_298,this.model.doc.cuerpo.cs_id_299,this.model.doc.cuerpo.cs_id_669);
		}
	}
} */

//limitante dependiente economico
operacionCs330() {
	//el valor del limitante se calcula en el 210
}

//medicina prepagada
operacionCs334(){
	
	const cas334 = this.model.doc.cuerpo.cs_id_334;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas334,"0")) {
		this.model.doc.cuerpo.cs_id_336="0";
		this.model.doc.cuerpo.cs_id_335="0";
	} else {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas268 = this.model.doc.cuerpo.cs_id_268;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas268,"0")) {
			this.model.doc.cuerpo.cs_id_334="0";
			this.model.doc.cuerpo.cs_id_336="0";
			this.model.doc.cuerpo.cs_id_335="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor de medicina prepagada ya está diligenciado en las rentas de trabajo como asalariado");
			return
		}
		
		const cas300 = this.model.doc.cuerpo.cs_id_300;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas300,"0")) {
			this.model.doc.cuerpo.cs_id_334="0";
			this.model.doc.cuerpo.cs_id_336="0";
			this.model.doc.cuerpo.cs_id_335="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor de medicina prepagada ya está diligenciado en las rentas de trabajo como trabajador independiente");
			return
		}
		this.operacionCs335();	
	}
}

//número de meses medicina prepagada
operacionCs336() {
   this.operacionCs335();		
}

//limitante medicina prepagada
operacionCs335(){
	
	const cas334 = this.model.doc.cuerpo.cs_id_334;
	const cas336 = this.model.doc.cuerpo.cs_id_336;
	
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas334,"0") 
  || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas336,"0")) {
		this.model.doc.cuerpo.cs_id_335="0";
		return 
	}
	
	const valorTope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,cas334,cas336);
	
	let cas335 = "0";
	const uvt16 = "608064";
	const uvt192 = "7296768";
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,valorTope,uvt16)) {
		cas335 =  this.dutilidades.redondearValorMoneda(cas334,true);
	} else {
		cas335 = uvt192;
	}
	this.model.doc.cuerpo.cs_id_335 = cas335;
}

// aportes voluntarios a cesantias...
operacionCs340(){
	// no tiene validaciones
	this.operacionCs341;
}

//limitante aportes voluntarios cesantias
operacionCs341(){
	//Valor se calcula en recalculo casillas 210
}


//donacion para investigacion
operacionCs337(){
	
	const cas337 = this.model.doc.cuerpo.cs_id_337;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas337,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas271 = this.model.doc.cuerpo.cs_id_271;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas271,"0")) {
			this.model.doc.cuerpo.cs_id_337="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
		
		const cas303 = this.model.doc.cuerpo.cs_id_303;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas303,"0")) {
			this.model.doc.cuerpo.cs_id_337="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas416 = this.model.doc.cuerpo.cs_id_416;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas416,"0")) {
			this.model.doc.cuerpo.cs_id_337="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		
		const cas523 = this.model.doc.cuerpo.cs_id_523;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas523,"0")) {
			this.model.doc.cuerpo.cs_id_337="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas no laborales");
			return
		}
	}
}

//4 x mil
operacionCs338(){
	this.operacionCs339();
}


//limitante 4 x mil
operacionCs339(){
	const porcentajeTopeMax = "0.50";
	const cas338 = this.model.doc.cuerpo.cs_id_338;
	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas338,porcentajeTopeMax);
  this.model.doc.cuerpo.cs_id_339 = this.dutilidades.redondearValorMoneda(resultado ,true);
}


//Perdidas renta no laboral ?
operacionCs342(){
	const cas342 = this.model.doc.cuerpo.cs_id_342;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas342,"0")) {
		this.model.doc.cuerpo.cs_id_343="0";
	}
}

//Valor pérdidas a compensar
operacionCs343(){
	const cas343 = this.model.doc.cuerpo.cs_id_343;
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas343,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor de las pérdidas a compensar no puede ser cero");
      return
   }
	
   //Otras validaciones se realizan en el 210
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ 
      this.showSave=true 
    };
  }
  /**
    * @desc Funcion para obtener los valores del modelo e operar con ellos
    * @param {DTipoOperacionAritmetica} operacion
    * @param {DDocumento} modelo
    * @param {Array<string>} campos
    * @param {boolean} formatear
    * @return {String}
    */
   protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
    let valores = [];
    for (let i in campos) {
        if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
            let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
            valores.push(valor);
            //valores.push(modelo.doc.cuerpo[campos[i]]);
        } else {
            valores.push('0');
        }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
}
//UVT 
private obtenerValorPeriodico110(): void {
  this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION).subscribe(
    data => this.setObjectFromResponse(data),
    error => console.log(error)
  )
}
private setObjectFromResponse(data: any): void {
  
      let model=<DValorPeriodico>data;
      this.UVT = String(model.valor);
   
}

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-prestacion-servicios-modal/renta-laboral-prestacion-servicios-modal.component.ts